// removed by extract-text-webpack-plugin
module.exports = {"weekday":"DateChoosers-weekday-gXqa9"};


//////////////////
// WEBPACK FOOTER
// ./modules/issFrontend/styles/DateChoosers.styl
// module id = ./modules/issFrontend/styles/DateChoosers.styl
// module chunks = 1